import React, { Component } from 'react';
import $ from 'jquery';
import jQuery from 'jquery';
import AdminLayout from './layout';

import FetchCall from '../../API/FetchCall';

import {   createSchool, getLocationList, emailExist_check,
  sclEdit, preSclList, sclReject, commonAPI, checkDuplicateUrl} from '../../API/FetchCall';
import { MOBILE_REGEX, URL_REGEX } from '../../constant.js';
import { Modal, ModalBody, Row, Col } from 'reactstrap';

import Geocode from "react-geocode";
import { Multiselect } from 'multiselect-react-dropdown';
import SimpleReactValidator from 'simple-react-validator';

Geocode.setApiKey("AIzaSyA9MtbfG_zlo64B2lqNMvigTBuXHkagKcE");
Geocode.setLanguage("en");
Geocode.setRegion("es");
Geocode.enableDebug();
const schooltypes = [{"id":1,"type_name":"Government"},{"id":2,"type_name":"Private"},{"id":3,"type_name":"NA"}];
const type =  [{"id":1,"name":"Regular"},{"id":2,"name":"Boarding"},{"id":3,"name":"NA"}];
const curriculam = [{"id":1,"name":"State Board / Matriculation"},{"id":2,"name":"CBSE"},{"id":3,"name":"ICSE"},{"id":4,"name":"IGCSE"},{"id":5,"name":"IB"},{"id":6,"name":"NIOS"},{"id":7,"name":"NA"}];
const boe = [{"category_id":12,"category_name":"Open School","is_parent":0,"parent":"Schools"},{"category_id":133,"category_name":"Special Needs","is_parent":0,"parent":"Schools"},{"category_id":142,"category_name":"Public School","is_parent":0,"parent":"Schools"},{"category_id":143,"category_name":"Private School","is_parent":0,"parent":"Schools"},{"category_id":144,"category_name":"Boarding School","is_parent":0,"parent":"Schools"},{"category_id":145,"category_name":"International School","is_parent":0,"parent":"Schools"},{"category_id":147,"category_name":"Alternative School","is_parent":0,"parent":"Schools"},{"category_id":174,"category_name":"E-School","is_parent":0,"parent":"Schools"}];
const locations = [{"id":1,"location":"Bengaluru","latitude":"12.9716","longitude":"77.5946","status":1,"sort_order":1},{"id":12,"location":"Chennai","latitude":"13.0569","longitude":"80.2425","status":1,"sort_order":2},{"id":11,"location":"Coimbatore","latitude":"11.0168","longitude":"76.9558","status":1,"sort_order":3},{"id":2,"location":"Hyderabad","latitude":"17.3850","longitude":"78.4867","status":1,"sort_order":4},{"id":24,"location":"Madurai","latitude":"9.9252","longitude":"78.1198","status":1,"sort_order":5},{"id":13,"location":"Mumbai","latitude":"19.0760","longitude":"72.8777","status":1,"sort_order":7},{"id":15,"location":"Kolkata","latitude":"22.5726","longitude":"88.3639","status":1,"sort_order":8},{"id":16,"location":"New Delhi","latitude":"28.6139","longitude":"77.2090","status":1,"sort_order":9},{"id":17,"location":"Jaipur","latitude":"26.9124","longitude":"75.7873","status":1,"sort_order":10},{"id":18,"location":"Chandigarh","latitude":"30.7333","longitude":"76.7794","status":1,"sort_order":11},{"id":19,"location":"Pune","latitude":"18.5204","longitude":"73.8567","status":1,"sort_order":12},{"id":20,"location":"Kochi","latitude":"9.9312","longitude":"76.2673","status":1,"sort_order":13},{"id":21,"location":"Noida","latitude":"28.5355","longitude":"77.3910","status":1,"sort_order":14},{"id":22,"location":"Agra","latitude":"27.1767","longitude":"78.0081","status":1,"sort_order":15},{"id":23,"location":"Puducherry","latitude":"11.9416","longitude":"79.8083","status":1,"sort_order":16},{"id":25,"location":"Tiruchirappalli","latitude":"10.7905","longitude":"78.7047","status":1,"sort_order":17},{"id":27,"location":"Hosur","latitude":"12.7409","longitude":"77.8253","status":1,"sort_order":4},{"id":26,"location":"Indore","latitude":"22.719568","longitude":"75.857727","status":1,"sort_order":18}];
const classifications = [{"id":1,"name":"Co-Ed"},{"id":2,"name":"Boys"},{"id":3,"name":"Girls"},{"id":4,"name":"NA"}];
const documents = [{"id":1,"document_name":"Birth Certificate"},{"id":2,"document_name":"Residential Proof"},{"id":3,"document_name":"Aadhar Card"},{"id":4,"document_name":"Passport Size Photos"},{"id":5,"document_name":"Immunization Certificate"},{"id":6,"document_name":"NA"}];
const amenetis = [{"id":1,"facility":"CCTV"},{"id":2,"facility":"AC Classes"},{"id":3,"facility":"Transportation"},{"id":4,"facility":"Food and Snacks"},{"id":5,"facility":"Outdoor Play area"},{"id":7,"facility":"Library"},{"id":6,"facility":"NA"}];
const timings = [{"id":1,"timing":"01:00"},{"id":2,"timing":"01:30"},{"id":3,"timing":"02:00"},{"id":4,"timing":"02:30"},{"id":5,"timing":"03:00"},{"id":6,"timing":"03:30"},{"id":7,"timing":"04:00"},{"id":8,"timing":"04:30"},{"id":9,"timing":"05:00"},{"id":10,"timing":"05:30"},{"id":11,"timing":"06:00"},{"id":12,"timing":"06:30"},{"id":13,"timing":"07:00"},{"id":14,"timing":"07:30"},{"id":15,"timing":"08:00"},{"id":16,"timing":"08:30"},{"id":17,"timing":"09:00"},{"id":18,"timing":"09:30"},{"id":19,"timing":"10:00"},{"id":20,"timing":"10:30"},{"id":21,"timing":"11:00"},{"id":22,"timing":"11:30"},{"id":23,"timing":"12:00"},{"id":24,"timing":"12:30"},{"id":25,"timing":"NA"}];
const grades = [{"id":1,"name":"Grade 1"},{"id":2,"name":"Grade 2"},{"id":3,"name":"Grade 3"},{"id":4,"name":"Grade 4"},{"id":5,"name":"Grade 5"},{"id":6,"name":"Grade 6"},{"id":7,"name":"Grade 7"},{"id":8,"name":"Grade 8"},{"id":9,"name":"Grade 9"},{"id":10,"name":"Grade 10"},{"id":11,"name":"Grade 11"},{"id":12,"name":"Grade 12"},{"id":13,"name":"NA"}];
const mops = [{"id":1,"payment_name":"Cash"},{"id":2,"payment_name":"Card"},{"id":3,"payment_name":"Cheque"},{"id":4,"payment_name":"Online Payments"},{"id":5,"payment_name":"NA"}];
const classfrequencies = [{"id":1,"freq_name":"Daily"},{"id":2,"freq_name":"Weekly"},{"id":3,"freq_name":"Monthly"},{"id":4,"freq_name":"NA"}];

class verticalSchool extends Component {

 constructor(props) {
    // alert(MOBILE_REGEX)
    super(props);
    this.state = {
      errors: [],
      ownerName: '',
      pageid: '',
      registration_no: '',
      user_type: 0,
      schoolName: '',
      email_id: '',
      phone_number: '',
      organisation_name:'',
      landline_number: '',
      website: '',
      state: '',
      location: 'Bengaluru',
      pincode: '',
      address: '',
      about_school: '',
      google_location: '',
      classification: '',
      board_of_education: '',
      grade: '',
      grade_to: '',
      schoolType: '',
      school_timimg: '',
      mode_of_payment: '',
      min_age: '',
      instruction_lang: '',
      establishment_Year: '',
      facilities: [],
      sub_types: [],
      avg_anual_fee: '',
      other_fee: '',
      addmission_fee: '',
      admission_link: '',
      processing_fee: '',
      required_document: [],
      admission_process: '',
      images: '',
      photos: '',
      timingList: timings,
      from_time_id: '',
      categorySubTypeList: curriculam,
      boeList: boe,
      ClassList: classfrequencies,
      documentList: documents,
      classificationList: classifications,
      facilitiesList: amenetis,
      schooltypeList: schooltypes,
      mopList: mops,
      gradeList: grades,
      latitude: '',
      longitude: '',
      other_rating: '',
      stdRatio: '',
      attachment_file: [],
      attachment_file_length: 0,
      attachment_fileName: [],
      from_time: '',
      from_time_cate: 'AM',
      to_time: '',
      to_time_cate: 'AM',
      edit_photos: '',
      delete_array: [],
      location_list: locations,
      edit_image: '',
      categorySubTypesList: type,
      tempBanner: '',
      has_scholarship: 0,
      scholarship_desc: '',
      preSclList: [],
      has_prescl: 2,
      prescl_link: 0,
      preview: false,
      edited_data: [],
      keywordsArr: [],
      edited: false,
      admission_open : '',
      admission_closed : '',
      seats_in : '',
      current_vacancies : '',
      duplicateverified:false
    };

    this.getKeywords(); this.getPresclList();
    this.id = this.props.match.params.id;
    if (this.id !== undefined) {
      console.log('here came the id', this.id)
      this.getSchoolInfo = this.getSchoolInfo.bind(this);
      this.getSchoolInfo();
    }
    this.validator = new SimpleReactValidator({
      validators: {
        checkExist: {  // name the rule
          message: 'The :attribute field is required.',
          rule: (val, params, validator) => {
            if (val === '' && this.state.edit_image === '') {
              return false;
            }
          },
          messageReplace: (message, params) => message.replace(':values', this.helpers.toSentence(params)),  // optional
          required: true  // optional
        },
        emailExist_check: {  // name the rule
          message: 'The :attribute Already Exist.',
          rule: (val, params, validator) => {
            return this.state.isEmailValid;
          },
          messageReplace: (message, params) => message.replace(':values', this.helpers.toSentence(params)),  // optional
          required: true  // optional
        },
        checkMobile: MOBILE_REGEX,
        checkUrl: URL_REGEX
      }
    });
   
    this.loadFile = this.loadFile.bind(this)
  }
  componentDidMount() {
    //this.LocationDataList();
    let user_data = localStorage.getItem("user_data");
    let auth_data = JSON.parse(user_data);
    let vendor_id = auth_data.login_id;
    this.setState({
      login_id: vendor_id,
      role: auth_data.role,
    });
    
    //this.gettiming(); 
    //this.getboe(); 
    //this.getclass_frequency(); 
    //this.getdocuments();
    //this.geteducation_system(); 
    //this.getfacilities(); 
    //this.getpayment_type(); 
    //this.getschool_type();
    //this.grade(); 
    //this.Sub_Cat_type(); 
    //this.Sub_Cat_types();

  }
  getKeywords = () => {
    commonAPI(JSON.stringify({ url: 'get_site_keywords', vertical:'school' })).then((res) => {
      if (res.status === 1) {
        this.setState({
          keywordsArr: res.results
        })
      }
    })
  }
  getPresclList = () => {
    preSclList().then(res => {
      if (res.status === 1) {
        this.setState({
          preSclList: res.list
        })
      }
    })
  }
  LocationDataList = async () => {
    try {
      const res = await getLocationList();
      if (res.status === 1) {
        console.log('location_list', res.results)

        this.setState({
          location_list: res.results,
          error: false
        });
      }

    } catch (error) {
      this.setState({ error: true });
    }
  };

  removeImage = e => {
    var delete_array = this.state.delete_array;
    delete_array.push(e)
    const updated = this.state.attachment_file.filter(item => item.name !== e)

    this.setState({
      attachment_file: updated,
      delete_array: delete_array,
    })
  }

  refreshSelectPreSchools = e =>{
    console.log("testing");
    this.getPresclList();
  }

  remove_img() {
    jQuery('#edit_image').remove();
  }

  loadFile(e) {
    var files = e.target.files
    this.setState({ attachment_file_length: files.length })
    if (files.length > 0) {
      jQuery('.upload-space').addClass('hide')
      jQuery('.upload-thumb').removeClass('hide')
      var fileArra = this.state.attachment_file

      //console.log('fileArra',fileArra)
      //var fileThumbArra = this.state.imgThumb;
      for (var i = 0; i < files.length; i++) {
        fileArra.push(e.target.files[i])
        this.setState({
          selectedFile: URL.createObjectURL(e.target.files[i]),
          attachment_file: fileArra
        })
      }
      this.clearValidationErr('attachment_file');
    }
  }
  async getSchoolInfo() {
    let response = await sclEdit(JSON.stringify({ id: this.id }));
    console.log(response);
    if (response.status === 1) {
      let data = response.data, edited_data = response.original;
      console.log('here the reci data ', data)
      this.setState({
        ownerName: data.owner_name,
        registration_no: data.registration_no,
        pageid: data.id,
        schoolName: data.organisation_name,
        email_id: data.email_id,
        phone_number: data.phone_number,
        landline_number: data.landline_no,
        website: data.website,
        state: data.state,
        location: data.location,
        pincode: data.pincode,
        address: data.address,
        country: data.country,
        isrefund: data.is_refund,
        about_school: data.about,
        google_location: data.google_location,
        schoolType: data.school_type,
        classification: data.classification,
        board_of_education: data.sub_categories.split(','),
        grade: data.grade,
        grade_to: data.grade_to,
        min_age: data.min_age,
        instruction_lang: data.inst_lang,
        establishment_Year: data.est_year,
        facilities: data.facilites.split(','),
        avg_anual_fee: data.avg_fee,
        other_fee: data.other_fee,
        addmission_fee: data.admit_fee,
        admission_link: data.admit_link,
        processing_fee: data.process_fee,
        required_document: data.documents.split(','),
        stdRatio: data.teacher_student_ratio,
        admission_process: data.admit_process,
        attachment_file: data.photo_arr,
        photos: data.photos,
        edit_image: data.images ? data.url + data.images : '',
        images: data.images,
        keywords: data.keywords ? data.keywords.split(';') : [],
        from_time: data.from_time,
        to_time: data.to_time,
        from_time_cate: data.from_time_cate,
        to_time_cate: data.to_time_cate,
        sub_types: data.sub_types.split(','),
        sub_type: data.sub_type.split(','),
        // categorySubTypeList: data.subtype_arr,
        latitude: data.latitude,
        longitude: data.longitude,
        other_rating: data.other_rating,
        has_scholarship: data.has_scholarship,
        scholarship_desc: data.scholarship_desc,
        has_prescl: data.prescl_id === 0 ? 2 : 1,
        prescl_link: data.prescl_id,
        edited: data.edited,
        edited_data: edited_data,

        admission_open : data.admission_open,
        admission_closed : data.admission_closed,
        seats_in : data.seats_in,
        current_vacancies : data.current_vacancies

      });
      this.Geocode_location(data.google_location);
    } else {
      this.props.history.push('/schoolsList')
    }

  }
  async grade() {
    let response = await FetchCall.getSchoolListDatas('grade');
    console.log(response);
    if (response) {
      this.setState({ gradeList: response.results });
    }
  }
  async gettiming() {
    let response = await FetchCall.getSchoolListDatas('timing');
    console.log(response);
    if (response) {
      this.setState({ timingList: response.results });
    }
  }
  async getboe() {
    let response = await FetchCall.getSubCategory('1');
    console.log('boeList', response);
    if (response) {
      this.setState({ boeList: response.results });
    }
  }
  async getclass_frequency() {
    let response = await FetchCall.getSchoolListDatas('class_frequency');
    console.log(response);
    if (response) {
      this.setState({ ClassList: response.results });
    }
  }
  async getdocuments() {
    let response = await FetchCall.getSchoolListDatas('documents');
    console.log(response);
    if (response) {
      this.setState({ documentList: response.results });
    }
  }
  async geteducation_system() {
    let response = await FetchCall.getSchoolListDatas('education_system');
    console.log(response);
    if (response) {
      this.setState({ classificationList: response.results });
    }
  }
  async getfacilities() {
    let response = await FetchCall.getSchoolListDatas('facilities');
    console.log(response);
    if (response) {
      this.setState({ facilitiesList: response.results });
    }
  }
  async getschool_type() {
    let response = await FetchCall.getSchoolListDatas('school_type');
    console.log(response);
    if (response) {
      this.setState({ schooltypeList: response.results });
    }
  }
  async getpayment_type() {
    let response = await FetchCall.getSchoolListDatas('payment_type');
    console.log(response);
    if (response) {
      this.setState({ mopList: response.results });
    }
  }

  async Sub_Cat_type() {
    let response = await FetchCall.getSchoolListDatas('curriculum');
    if (response.status === 1) {
      this.setState({ categorySubTypeList: response.results, cat_type: true, cat_type1: false, cat_type2: false });
    } else {
      this.setState({ cat_type: false });
    }
  }

  async Sub_Cat_types() {
    let response = await FetchCall.getSchoolListDatas('type');
    if (response.status === 1) {
      this.setState({ categorySubTypesList: response.results, cat_type: true, cat_type1: false, cat_type2: false });
    } else {
      this.setState({ cat_type: false });
    }
  }

  UNSAFE_componentWillMount() { }
  componentDidUpdate() {
    window.jQuery('.selectpicker').selectpicker('refresh');
  }

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
    if (e.target.name === 'google_location')
      this.Geocode_location();
  };
  
  handleChangeName = (e) => {
    if (e.target.value !== '')
      this.validateNameAndUrl(e.target.value);
  };

  validateNameAndUrl(){


    let ins = JSON.stringify({
      name: this.state.schoolName,
      id:this.id,
      vertical:'schools'
    });

    checkDuplicateUrl(ins).then((res) => {

        if(res.status===1){

           this.setState({duplicateverified: true });


        }else{

          this.setState({duplicateverified: false });
           
        }

        $(".resultant").html(res.resultant);

    }); 

  }

  validateMail = (value, catgry, vendr_id, pageid) => {
    let name = 'email_id';
    let type_name = 'isEmailValid';
    let req = JSON.stringify({
      [name]: value,
      category: catgry,
      vendor_id: vendr_id
    });
    emailExist_check(req).then(res => {
      console.log('valuee', res);
      if (res.status === 1) {
        this.setState({
          [type_name]: false
        });
      } else {
        // return res.status;
        this.setState({
          [type_name]: true
        });
      }
    });
  }
  handleNumberChange = (e) => {
    let regexp = /^[0-9\b]+$/
    let Mnumber = e.target.value;

    if (e.target.value === '' || regexp.test(e.target.value)) {
      this.setState({ [e.target.name]: Mnumber })
    }
    this.Geocode_location();
  }
  isEmailValid = () => {
    var email = this.state.email_id;
    const reg = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

    if (reg.test(email) !== true) {
      this.showValidationErr("email_id", "Please Enter Valid Email id");
      return false;
    } else {
      this.clearValidationErr("email_id");
      return true;
    }

  }
  islengthvalidate(value, ctrl) {
    if (ctrl === 1) {
      console.log("length", value.length);
      if (value.length !== 10) {
        this.showValidationErr("phone_number", "Phone Number should be 10 digits");
        return false;
      } else {
        this.clearValidationErr("phone_number");
        return true;
      }
    }
    else {
      if (value.length <= 11) {
        this.showValidationErr("landline_no", "Landline number should be 12 digits");
        return false;
      } else {
        this.clearValidationErr("landline_no");
        return true;
      }
    }
  }
  showValidationErr(elm, msg) {
    console.log(elm, msg);
    this.setState((prevState) => ({ errors: [...prevState.errors, { elm, msg }] }));
  }
  clearValidationErr(elm) {
    this.setState((prevState) => {
      let newArr = [];
      for (let err of this.state.errors) {
        if (elm !== err.elm) {
          newArr.push(err);
        }
      }
      return { errors: newArr };
    })

  }
  handlePaste = (e) => {
    this.Geocode_location();

  };

  handleFile = (e) => {
    // this.Geocode_location();
    const propName = e.target.name;
    const files = e.target.files[0];
    this.setState({ [propName]: files });
    const reader = new FileReader();
    let THIS = this;
    reader.addEventListener("load", function () {
      // convert image file to base64 string
      THIS.setState({
        tempBanner: reader.result
      });
    }, false);

    if (files) {
      reader.readAsDataURL(files);
    } else {
      THIS.setState({
        tempBanner: ''
      });
    }
  };
  handleFileMultiple = (e) => {
    this.setState({ [e.target.name]: e.target.files });
  };
  handleSelectGradeFrom = (e) => {
    let grade_from = parseInt(e.target.value,10);
    let grade_to = parseInt(this.state.grade_to,10);
    if ((grade_from >= grade_to)) {
      this.setState({
        grade: ''
      });
      let toastr = '';
      toastr = window.toastr.error;
      toastr('', 'Grade From should be lesser than grade to! ', {
        positionClass: "toast-bottom-right",
        containerId: "toast-bottom-right"
      });
      return false;
    }
    const propName = e.target.name;
    const value = [...e.target.selectedOptions].map((item) => item.value);
    this.setState({ [propName]: value });
  };
  handleSelectGradeto = (e) => {
    let grade_from = parseInt(this.state.grade,10);
    let grade_to = parseInt(e.target.value,10);
    if ((grade_to <= grade_from)) {
      this.setState({
        grade_to: ''
      });
      let toastr = '';
      toastr = window.toastr.error;
      toastr('', 'Grade to should be greater than grade from! ', {
        positionClass: "toast-bottom-right",
        containerId: "toast-bottom-right"
      });
      return false;
    }
    const propName = e.target.name;
    const value = [...e.target.selectedOptions].map((item) => item.value);
    console.log(propName, value);
    this.Sub_Cat_type(value);
    this.setState({ [propName]: value });
  };
  handleSelect = (e) => {
    const propName = e.target.name;
    const value = [...e.target.selectedOptions].map((item) => item.value);
    console.log(propName, value);
    this.Sub_Cat_type(value);

    this.setState({ [propName]: value });
  };

  onSelect = (selectedList) => {
    let keywords = [];
    selectedList.forEach((item, i) => {
      keywords.push(item)
    });
    this.setState({
      keywords: keywords,
    });
  }
  onRemove = (selectedList, removedItem) => {
    let keywords = [];
    selectedList.forEach((item, i) => {
      keywords.push(item)
    });
    this.setState({
      keywords: keywords,
    });
  }
  handleSelectCat1 = (e) => {
    const propName = e.target.name;
    const value = [...e.target.selectedOptions].map((item) => item.value);
    this.setState({ [propName]: value });
  }

  Geocode_location(location = '') {
    Geocode.fromAddress(location ? location : this.state.google_location).then(
      response => {
        const { lat, lng } = response.results[0].geometry.location;
        if (lat && lng)
          this.get_location(lat, lng);
      },
      error => {
        console.error(error);
      }
    );

  }

  /*
  checkUrlDuplicate= (e) => {
      
     if(this.state.schoolName==''){

      $(".verifiedurl").removeClass('greentext').addClass('redtext').html('Please enter organisation name');

     }else{


      let ins = JSON.stringify({
        name: this.state.schoolName,
        id:this.id,
        vertical:'schools'
      });

      checkifduplicateExist(ins).then((res) => {

          if(res.status==1){

             this.setState({duplicate: true });

            $(".verifiedurl").removeClass('greentext').addClass('redtext').html('URL not available');

          }else{

            this.setState({duplicate: false });
            $(".verifiedurl").removeClass('redtext').addClass('greentext').html('URL available');
          }

      });
   
     }

  }
*/

  get_location(lat, lng) {
    this.setState({
      latitude: lat,
      longitude: lng
    });
  }
  handlePreview = (e) => {
    e.preventDefault();
    if (this.validator.allValid()) {
      this.setState({
        preview: true
      })
    } else {
      this.validator.showMessages();
      this.forceUpdate();
    }
  }

  render() {
    this.validator.purgeFields();
    const { edited, edited_data } = this.state;
    console.log('edit_image', this.state.edit_image)

    console.log('tempBanner', this.state.tempBanner)

        return (
            <React.Fragment>
                <AdminLayout>
                    
                      
                        <div class="col-lg-12 grid-margin stretch-card">
              <div class="card">
                <div class="card-body">
                  <h4 class="card-title">School - Add</h4>
                 
 
                    <div class="row">
                      
                        <div class="col-lg-12">
                       

                      <div className="main-content col-md-12 col-xs-12">

                <div className="content-sec col-md-12 col-xs-12 pad-no mar-t-no">
                  <div className="tab-content">
                    <div id="company-info" className="tabactive">
                      <form
                        encType="multipart/form-data"
                        method="post"
                        onSubmit={this.handlePreview}
                        autoComplete="off"
                        className="custom-form invoice-form col-md-12 col-xs-12 legend-form pad-no"
                      >

<div className="box-shadow-custom">

<div class="row">

        <div className="form-group col-md-8">
        <label className={edited && (edited_data.organisation_name !== this.state.schoolName) && 'edited-field'}>
          Organization Name <span className="astrick">*</span>
        </label>
        <input

          type="text"
          name="schoolName"
          value={this.state.schoolName}
          onChange={this.handleChange}
          onKeyUp={this.handleChangeName}
          className="form-control"
        />

        
        <div> 
       
      
        </div>
        {
          this.state.user_type >= 1 &&
          (
            this.validator.message('Organization Name', this.state.schoolName, 'required', { className: 'text-danger' })
          )
        }
      </div>
      <div class="col-md-8">

            <div class="resultant"></div>

      </div>

  </div>
</div>
                        <div className="box-shadow-custom">

                        
                          <div className="row">
                            <div className="form-group col-md-4">
                              <label className={edited && (edited_data.registration_no !== this.state.registration_no) && 'edited-field'}>
                                Registration No {this.state.user_type === 1 && <span className="astrick">*</span>}
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                name="registration_no"
                                value={this.state.registration_no}
                                onChange={this.handleChange}
                              />
                              {
                                this.state.user_type === 1 ?
                                  (
                                    this.validator.message('Registration No', this.state.registration_no, 'required', { className: 'text-danger' })
                                  ) :
                                  (
                                    this.validator.message('Registration No', this.state.registration_no, '', { className: 'text-danger' })
                                  )
                              }
                            </div>
                            <div className="form-group col-md-4">
                              <label className={edited && (edited_data.owner_name !== this.state.ownerName) && 'edited-field'}>
                                Owner Name {this.state.user_type === 1 && <span className="astrick">*</span>}
                              </label>
                              <input

                                type="text"
                                className="form-control"
                                name="ownerName"
                                value={this.state.ownerName}
                                onChange={this.handleChange}
                              />
                              {
                                this.state.user_type === 1 ?
                                  (
                                    this.validator.message('Owner Name', this.state.ownerName, 'required', { className: 'text-danger' })
                                  ) :
                                  (
                                    this.validator.message('Owner Name', this.state.ownerName, '', { className: 'text-danger' })
                                  )
                              }
                            </div>
                            
                            <div className="form-group col-md-4">
                              <label className={edited && (edited_data.sub_categories !== this.state.board_of_education) && 'edited-field'}>
                                Type of School
                                <span className="astrick">*</span>
                              </label>
                              <div className="custom-select-drop dropdown">
                                <select
                                  name="board_of_education"
                                  id="board_of_education"
                                  onChange={this.handleSelect}
                                  value={this.state.board_of_education}
                                  className="form-control selectpicker"
                                  multiple
                                >
                                  {this.state.boeList.length > 0 &&
                                    this.state.boeList.map((item, i) => {
                                      return (
                                        <option value={item.category_id} >
                                          {item.category_name}
                                        </option>
                                      )
                                    })}
                                </select>
                                {this.validator.message('Type of School', this.state.board_of_education, 'required', { className: 'text-danger' })}
                              </div>
                            </div>


                            <div className="form-group col-md-4">
                              <label
                                className={edited && (edited_data.sub_types !== this.state.sub_types) && 'edited-field'}>
                                Board Of Education <span className="astrick">*</span>
                              </label>
                              <div className='custom-select-drop dropdown'>
                                <select
                                  multiple
                                  onChange={this.handleSelectCat1}
                                  name="sub_types"
                                  value={this.state.sub_types}
                                  className='form-control selectpicker' >
                                  {/* <option value="">select</option> */}
                                  {this.state.categorySubTypeList.length > 0 &&
                                    this.state.categorySubTypeList.map((item, i) => {
                                      return (
                                        <option value={item.id} >
                                          {item.name}
                                        </option>
                                      )
                                    })}
                                </select>
                                {this.validator.message('Board Of Education', this.state.sub_types, 'required', { className: 'text-danger' })}
                              </div>
                            </div>


                            <div className="form-group col-md-4">
                              <label className={edited && (edited_data.sub_type !== this.state.sub_type) && 'edited-field'}>
                                Campus Type<span className="astrick">*</span>
                              </label>
                              <div className='custom-select-drop dropdown'>
                                <select
                                  multiple
                                  onChange={this.handleSelectCat1}
                                  name="sub_type"
                                  value={this.state.sub_type}
                                  className='form-control selectpicker' >
                                  {/* <option value="">select</option> */}
                                  {this.state.categorySubTypesList.length > 0 &&
                                    this.state.categorySubTypesList.map((item, i) => {
                                      return (
                                        <option value={item.id} >
                                          {item.name}
                                        </option>
                                      )
                                    })}
                                </select>
                                {this.validator.message('Campus Type', this.state.sub_type, 'required', { className: 'text-danger' })}
                              </div>
                            </div>


                          </div>
                        </div>
                        <div className="box-shadow-custom">
                          <div className="row">
                            <div className="col-md-12 col-xs-12">
                              <span className="form-legend">
                                Address Information
                              </span>
                            </div>
                            <div className="form-group col-md-4">
                              <label className={edited && (edited_data.email_id !== this.state.email_id) && 'edited-field'}>
                                Email Id<span className="astrick">*</span>
                              </label>
                              <input
                                type="text"
                                name="email_id"
                                value={this.state.email_id}
                                onChange={this.handleChange}
                                className="form-control"
                              />
                              {this.validator.message('Email Id', this.state.email_id, 'emailExist_check', { className: 'text-danger' })}
                              {/* {this.validator.message('Email Id', this.state.email_id, 'required|email', { className: 'text-danger' })} */}
                            </div>
                            <div className="form-group col-md-4">
                              <label className={edited && (edited_data.phone_number !== this.state.phone_number) && 'edited-field'}>
                                Phone Number<span className="astrick">*</span>
                              </label>
                              <input
                                type="text"
                                name="phone_number"
                                value={this.state.phone_number}
                                onChange={this.handleChange}
                                className="form-control"
                              />
                              {this.validator.message('Phone Number', this.state.phone_number, '', { className: 'text-danger' })}
                              {/* {this.validator.message('Phone Number', this.state.phone_number, 'required|checkMobile|min:10|max:60', { className: 'text-danger' })} */}
                            </div>
                            <div className="form-group col-md-4">
                              <label className={edited && (edited_data.landline_no !== this.state.landline_number) && 'edited-field'}>
                                Landline Number<span className="astrick">*</span>
                              </label>
                              <input
                                type="text"
                                name="landline_number"
                                value={this.state.landline_number}
                                onChange={this.handleChange}
                                className="form-control landline_number" maxlength="12"
                              />
                              {this.validator.message('Landline Number', this.state.landline_number, '', { className: 'text-danger' })}
                              {/* {this.validator.message('Landline Number', this.state.landline_number, 'required|numeric', { className: 'text-danger' })} */}
                            </div>

                            <div className="form-group col-md-4">
                              <label className={edited && (edited_data.website !== this.state.website) && 'edited-field'}>
                                Website<span className="astrick">*</span>
                              </label>
                              <input
                                type="text"
                                name="website"
                                value={this.state.website}
                                onChange={this.handleChange}
                                className="form-control"
                              />
                              {this.validator.message('Website', this.state.website, '', { className: 'text-danger' })}
                              {/* {this.validator.message('Website', this.state.website, 'required|checkUrl', { className: 'text-danger' })} */}
                            </div>
                            <div className="form-group col-md-4">
                              <label className={edited && (edited_data.state !== this.state.state) && 'edited-field'}>
                                State<span className="astrick">*</span>
                              </label>
                              <input
                                type="text"
                                name="state"
                                value={this.state.state}
                                onChange={this.handleChange}
                                className="form-control"
                              />
                              {this.validator.message('State', this.state.state, 'required', { className: 'text-danger' })}
                            </div>
                            <div className="form-group col-md-4">
                              <label className={edited && (edited_data.location !== this.state.location) && 'edited-field'}>
                                Location<span className="astrick">*</span>
                              </label>
                              <select
                                name="location"
                                id="location"
                                onChange={this.handleSelect}
                                value={this.state.location}
                                className="form-control selectpicker"
                              >
                                {this.state.location_list.length > 0 &&
                                  this.state.location_list.map((item, i) => {
                                    return (
                                      <option value={item.location} >
                                        {item.location}
                                      </option>
                                    )
                                  })}
                              </select>
                              {this.validator.message('Location', this.state.location, 'required', { className: 'text-danger' })}
                            </div>
                            {/* <div className="form-group col-md-4">
                              <label>
                                Country<span className="astrick">*</span>
                              </label>
                              <input
                                required
                                type="text"
                                name="country"
                                value={this.state.country}
                                onChange={this.handleChange}
                                className="form-control"
                              />
                            </div> */}
                            <div className="form-group col-md-4">
                              <label className={edited && (edited_data.pincode !== this.state.pincode) && 'edited-field'}>
                                Pincode<span className="astrick">*</span>
                              </label>
                              <input
                                type="text"
                                name="pincode"
                                value={this.state.pincode}
                                onChange={this.handleNumberChange}
                                className="form-control"
                              />
                              {this.validator.message('Pincode', this.state.pincode, 'required', { className: 'text-danger' })}
                            </div>
                            <div className="form-group col-md-4">
                              <label className={edited && (edited_data.address !== this.state.address) && 'edited-field'}>
                                Address<span className="astrick">*</span>
                              </label>
                              <input
                                type="text"
                                name="address"
                                value={this.state.address}
                                onChange={this.handleChange}
                                className="form-control"
                              />
                              {this.validator.message('Address', this.state.address, 'required', { className: 'text-danger' })}
                            </div>

                            <div className="form-group col-md-4">
                              <label className={edited && (edited_data.google_location !== this.state.google_location) && 'edited-field'}>
                                Google Location Address
                                <span className="astrick">*</span>
                              </label>
                              <input
                                type="text"
                                name="google_location"
                                value={this.state.google_location}
                                onChange={this.handleChange}
                                onPaste={this.handlePaste}
                                className="form-control"
                              />
                              {this.validator.message('Google Location', this.state.google_location, 'required', { className: 'text-danger' })}
                            </div>
                            <div className="form-group col-md-4">
                              <label className={edited && (edited_data.latitude !== this.state.latitude) && 'edited-field'}>
                                Latitude
                                <span className="astrick">*</span>
                              </label>
                              <input
                                type="text"
                                name="latitude"
                                value={this.state.latitude}
                                onChange={this.handleChange}

                                className="form-control"
                              />
                              {this.validator.message('Latitude', this.state.latitude, 'required', { className: 'text-danger' })}
                            </div>
                            <div className="form-group col-md-4">
                              <label className={edited && (edited_data.longitude !== this.state.longitude) && 'edited-field'}>
                                Longitude
                                <span className="astrick">*</span>
                              </label>
                              <input
                                type="text"
                                name="longitude"
                                value={this.state.longitude}
                                onChange={this.handleChange}

                                className="form-control"
                              />
                              {this.validator.message('Longitude', this.state.longitude, 'required', { className: 'text-danger' })}
                            </div>
                            <div className="form-group col-md-4">
                              <label className={edited && (edited_data.other_rating !== this.state.other_rating) && 'edited-field'}>
                                Google Rating
                                <span className="astrick">*</span>
                              </label>
                              <input
                                type="number"
                                step='0.01'
                                name="other_rating"
                                value={this.state.other_rating}
                                onChange={this.handleChange}
                                max='5'
                                className="form-control"
                              />
                              {this.validator.message('Google Rating', this.state.other_rating, 'required', { className: 'text-danger' })}
                            </div>
                            <div className="form-group col-md-12">
                              <label className={edited && (edited_data.about !== this.state.about_school) && 'edited-field'}>
                                About the School<span className="astrick">*</span>
                              </label>
                              <textarea
                                style={{ 'height': '300px' }}
                                type="text"
                                name="about_school"
                                value={this.state.about_school}
                                onChange={this.handleChange}
                                className="form-control"
                              />
                              {this.validator.message('About', this.state.about_school, 'required', { className: 'text-danger' })}
                            </div>

                          </div>
                        </div>

                        <div className="box-shadow-custom">
                          <div className="row">
                            <div className="col-md-12 col-xs-12">
                              <span className="form-legend">Key Information</span>
                            </div>
                            <div className="form-group col-md-4">
                              <label className={edited && (edited_data.school_type !== this.state.schoolType) && 'edited-field'}>
                                School type<span className="astrick">*</span>
                              </label>
                              <div
                                name="school_type"
                                id="schoolType"
                                className="custom-select-drop dropdown"
                              >
                                <select
                                  name="schoolType" id="schoolType"
                                  value={this.state.schoolType}
                                  onChange={this.handleChange} defaultValue={0}
                                  className="form-control selectpicker"
                                  title='Select'
                                >
                                  {this.state.schooltypeList.length > 0 &&
                                    this.state.schooltypeList.map((item, i) => {
                                      return (
                                        <option value={item.id} >
                                          {item.type_name}
                                        </option>
                                      )
                                    })}
                                </select>
                                {this.validator.message('School type', this.state.schoolType, 'required', { className: 'text-danger' })}
                              </div>
                            </div>
                            <div className="form-group col-md-4">
                              <label className={edited && (edited_data.classification !== this.state.classification) && 'edited-field'}>
                                Classification<span className="astrick">*</span>
                              </label>
                              <div className="custom-select-drop dropdown">
                                <select
                                  name="classification"
                                  id="classification"
                                  value={this.state.classification}
                                  onChange={this.handleSelect}
                                  className="form-control selectpicker"
                                  title='Select'
                                >
                                  {this.state.classificationList.length > 0 &&
                                    this.state.classificationList.map((item, i) => {
                                      return (
                                        <option value={item.id} >
                                          {item.name}
                                        </option>
                                      )
                                    })}
                                </select>
                                {this.validator.message('Classification', this.state.classification, 'required', { className: 'text-danger' })}
                              </div>
                            </div>
                            <div className="form-group col-md-4 input-group-cus">
                              <div>
                                <label
                                  className={edited &&
                                    ((edited_data.grade !== this.state.grade) || (edited_data.grade_to !== this.state.grade_to))
                                    && 'edited-field'}>Grades From/ To
                                </label>
                                <div className="custom-select-drop dropdown">
                                  <select
                                    name="grade"
                                    id="grade"
                                    onChange={this.handleSelectGradeFrom}
                                    value={this.state.grade}
                                    className="form-control selectpicker"
                                    title='Select'
                                  >
                                    {this.state.gradeList.length > 0 && this.state.gradeList.map((item, i) => {
                                      return (
                                        <option value={item.id}> {item.name}</option>
                                      );
                                    })}
                                  </select>
                                  {this.validator.message('Grades', this.state.grade, 'required', { className: 'text-danger' })}
                                </div>
                              </div>
                              <div>
                                <label>&nbsp;</label>
                                <div className="custom-select-drop dropdown">
                                  <select
                                    name="grade_to"
                                    id="gradeto"
                                    value={this.state.grade_to}
                                    onChange={this.handleSelectGradeto}
                                    className="form-control selectpicker"
                                    title='Select'
                                  >
                                    {this.state.gradeList.length > 0 && this.state.gradeList.map((item, i) => {
                                      return (
                                        <option value={item.id}> {item.name}</option>
                                      );
                                    })}
                                  </select>
                                  {this.validator.message('Grades', this.state.grade_to, 'required', { className: 'text-danger' })}
                                </div>
                              </div>
                            </div>



                            <div className="form-group col-md-4 input-group-cus">
                              <div>
                                <label
                                  className={edited &&
                                    ((edited_data.from_time !== this.state.from_time) || (edited_data.from_time_cate !== this.state.from_time_cate))
                                    && 'edited-field'}>From Timing
                                </label>
                                <div className="custom-select-drop dropdown">
                                  <select
                                    className="form-control selectpicker"
                                    onChange={this.handleSelect}
                                    value={this.state.from_time}
                                    name="from_time"
                                    title='Select'
                                  >
                                    {this.state.timingList.length > 0 &&
                                      this.state.timingList.map((item, i) => {
                                        return (
                                          <option value={item.id} >
                                            {item.timing}
                                          </option>
                                        )
                                      })}
                                  </select>
                                  {this.validator.message('Timing', this.state.from_time, 'required', { className: 'text-danger' })}
                                </div>
                              </div>

                              <div>
                                <label>&nbsp;</label>
                                <div className="custom-select-drop dropdown">
                                  <select
                                    className="form-control selectpicker"
                                    onChange={this.handleSelect}
                                    value={this.state.from_time_cate}
                                    name="from_time_cate"
                                  >
                                    <option value="AM">AM</option>
                                    <option value="PM">PM</option>
                                  </select>
                                </div>
                              </div>
                            </div>

                            <div className="form-group col-md-4 input-group-cus">
                              <div>
                                <label
                                  className={edited &&
                                    ((edited_data.to_time !== this.state.to_time) || (edited_data.to_time_cate !== this.state.to_time_cate))
                                    && 'edited-field'}>To Timing   </label>
                                <div className="custom-select-drop dropdown">
                                  <select
                                    className="form-control selectpicker"
                                    onChange={this.handleSelect}
                                    value={this.state.to_time}
                                    name="to_time"
                                    title='Select'
                                  >
                                    {this.state.timingList.length > 0 &&
                                      this.state.timingList.map((item, i) => {
                                        return (
                                          <option value={item.id} >
                                            {item.timing}
                                          </option>
                                        )
                                      })}
                                  </select>
                                  {this.validator.message('Timing', this.state.to_time, 'required', { className: 'text-danger' })}
                                </div>
                              </div>

                              <div>
                                <label>&nbsp;</label>
                                <div className="custom-select-drop dropdown">
                                  <select
                                    className="form-control selectpicker"
                                    onChange={this.handleSelect}
                                    value={this.state.to_time_cate}
                                    name="to_time_cate"
                                  >
                                    <option value="AM">AM</option>
                                    <option value="PM">PM</option>
                                  </select>
                                </div>
                              </div>
                            </div>
                            <div className="form-group col-md-4">
                              <label className={edited && (edited_data.min_age !== this.state.min_age) && 'edited-field'}>Min Age of Admission
                              </label>
                              <input

                                type="text"
                                name="min_age"
                                value={this.state.min_age}
                                onChange={this.handleChange}
                                className="form-control"
                              />
                              {this.validator.message('Min Age of Admission', this.state.min_age, 'required', { className: 'text-danger' })}
                            </div>
                            <div className="form-group col-md-4">
                              <label
                                className={edited && (edited_data.inst_lang !== this.state.instruction_lang) && 'edited-field'}>Instruction Language
                              </label>
                              <input
                                type="text"
                                name="instruction_lang"
                                value={this.state.instruction_lang}
                                onChange={this.handleChange}
                                className="form-control"
                              />
                              {this.validator.message('Instruction Language', this.state.instruction_lang, 'required', { className: 'text-danger' })}
                            </div>
                            <div className="form-group col-md-4">
                              <label
                                className={edited && (edited_data.teacher_student_ratio !== this.state.stdRatio) && 'edited-field'}>Teacher:Student Ratio
                              </label>
                              <input
                                type="text"
                                name="stdRatio"
                                placeholder='ex:- 1:28'
                                value={this.state.stdRatio}
                                onChange={this.handleChange}
                                className="form-control"
                              />
                              {this.validator.message('Teacher:Student Ratio', this.state.stdRatio, 'required', { className: 'text-danger' })}
                            </div>
                            <div className="form-group col-md-4">
                              <label
                                className={edited && (edited_data.est_year !== this.state.establishment_Year) && 'edited-field'}>
                                Establishment Year
                                <span className="astrick">*</span>
                              </label>
                              <input
                                type="text"
                                name="establishment_Year"
                                value={this.state.establishment_Year}
                                onChange={this.handleChange}
                                className="form-control"
                              />
                              {this.validator.message('Establishment Year', this.state.establishment_Year, '', { className: 'text-danger' })}
                              {/* {this.validator.message('Establishment Year', this.state.establishment_Year, 'required|numneric|min:4|max:4', { className: 'text-danger' })} */}
                            </div>
                            <div className="form-group col-md-4">
                              <label
                                className={edited && (edited_data.facilites !== this.state.facilities) && 'edited-field'}>Amenities
                              </label>
                              <div className="custom-select-drop dropdown">
                                <select
                                  multiple
                                  name="facilities"
                                  id="facilities"
                                  onChange={this.handleSelect}
                                  value={this.state.facilities}
                                  className="form-control selectpicker"
                                  title='Select'
                                >
                                  {this.state.facilitiesList.length > 0 &&
                                    this.state.facilitiesList.map((item, i) => {
                                      return (
                                        <option value={item.id} >
                                          {item.facility}
                                        </option>
                                      )
                                    })}
                                </select>
                                {this.validator.message('Amenities', this.state.facilities, 'required', { className: 'text-danger' })}
                              </div>
                            </div>
                            <div class="form-group col-md-4">
                              <label
                                className={edited && (edited_data.has_scholarship !== this.state.has_scholarship) && 'edited-field'}> Is Scholarship Avail <span class="astrick">*</span>
                              </label>
                              <select
                                className='form-control selectpicker'
                                name='has_scholarship'
                                value={this.state.has_scholarship}
                                title='Select'
                                onChange={this.handleSelect}>
                                <option value='0'>NA</option>
                                <option value='1'>Yes</option>
                                <option value='2'>No</option>
                              </select>
                              {this.validator.message('Scholarship', this.state.has_scholarship, 'required', { className: 'text-danger error-msg' })}

                            </div>
                            {(this.state.has_scholarship === 1 && (
                              <div class="form-group col-md-4">
                                <label
                                  className={edited && (edited_data.scholarship_desc !== this.state.scholarship_desc) && 'edited-field'}> Scholarship Description <span class="astrick">*</span>
                                </label>
                                <textarea className="form-control" name='scholarship_desc' onChange={this.handleChange} value={this.state.scholarship_desc}></textarea>
                                {this.validator.message('Scholarship Descrption', this.state.scholarship_desc, 'required', { className: 'text-danger error-msg' })}
                              </div>
                            ))}
                            <div class="form-group col-md-4">
                              <label
                                className={edited && (edited_data.prescl_id !== this.state.prescl_link) && 'edited-field'}> Is School has Preschool<span class="astrick">*</span>
                              </label>
                              <select
                                className='form-control selectpicker'
                                name='has_prescl'
                                value={this.state.has_prescl}
                                title='Select'
                                onChange={this.handleSelect}>
                                <option value='1'>Yes</option>
                                <option value='2'>No</option>
                              </select>
                              {this.validator.message('Preschool', this.state.has_prescl, 'required', { className: 'text-danger error-msg' })}

                            </div>
                            {(this.state.has_prescl === 1 && (
                              <div class="form-group col-md-4">
                                <label
                                  className={edited && (edited_data.prescl_id !== this.state.prescl_link) && 'edited-field'}> Select Preschool<span class="astrick">*</span>
                                </label>
                                <select
                                  className='form-control selectpicker'
                                  name='prescl_link'
                                  value={this.state.prescl_link}
                                  title='Select' data-live-search='true'
                                  onChange={this.handleSelect}>
                                  {this.state.preSclList.map((item, i) => {
                                    return (
                                      <option value={item.id}>{item.name}</option>
                                    )
                                  })}
                                </select>
                                {this.validator.message('Preschool', this.state.prescl_link, 'required', { className: 'text-danger error-msg' })}
                                  <span>If no match found, Please go <a href="/vertical/preschool/add" target="_blank">here</a> and add preschool and click <span onClick={this.refreshSelectPreSchools}>here</span> to refresh the list</span>
                              </div>
                            ))}
                          </div>
                        </div>


                        < div className="box-shadow-custom">
                          <div className="row">
                            <div className="col-md-12 col-xs-12">
                              <span className="form-legend">
                                Admission Details
                              </span>
                            </div>

  
                            <div className="form-group col-md-4">
                              <label>
                                Annual Admission Timeline From
                              </label>
                              <div className="custom-select-drop dropdown">
                               <select
                                  name="admission_open"
                                  id="admission_open"
                                  className="form-control"
                                  // data-live-search="true"
                                  value={this.state.admission_open}
                                  onChange={this.handleSelect}
                                  title='Select'
                                > 
                                  <option value="">Select</option>
                                  <option value="January">January</option>
                                  <option value="February">February</option> 
                                  <option value="March">March</option>
                                  <option value="April">April</option>
                                  <option value="May">May</option>
                                  <option value="June">June</option>
                                  <option value="July">July</option>
                                  <option value="August">August</option>
                                  <option value="September">September</option>
                                  <option value="October">October</option>
                                  <option value="November">November</option>
                                  <option value="December">December</option>
                                </select>
                              </div>
                            </div>

                            <div className="form-group col-md-4">
                              <label>
                                Annual Admission Timeline To
                              </label>
                              <div className="custom-select-drop dropdown">
                               <select
                                  name="admission_closed"
                                  id="admission_closed"
                                  className="form-control"
                                  // data-live-search="true"
                                  value={this.state.admission_closed}
                                  onChange={this.handleSelect}
                                  title='Select'
                                > 
                                  <option value="">Select</option>
                                  <option value="January">January</option>
                                  <option value="February">February</option> 
                                  <option value="March">March</option>
                                  <option value="April">April</option>
                                  <option value="May">May</option>
                                  <option value="June">June</option>
                                  <option value="July">July</option>
                                  <option value="August">August</option>
                                  <option value="September">September</option>
                                  <option value="October">October</option>
                                  <option value="November">November</option>
                                  <option value="December">December</option>
                                </select>
                              </div>
                            </div>

                            <div className="form-group col-md-4">
                              <label
                                className={edited && (edited_data.admit_link !== this.state.admission_link) && 'edited-field'}>
                                Admission Link <span className="astrick">*</span>
                              </label>
                              <input
                                type="text"
                                name="admission_link"
                                value={this.state.admission_link}
                                onChange={this.handleChange}
                                className="form-control"
                              />
                              {this.validator.message('Admission Link', this.state.admission_link, '', { className: 'text-danger' })}
                              {/* {this.validator.message('Admission Link', this.state.admission_link, 'required|url', { className: 'text-danger' })} */}
                            </div>
                            <div className="form-group col-md-4">
                              <label
                                className={edited && (edited_data.avg_fee !== this.state.avg_anual_fee) && 'edited-field'}>
                                Indicative Annual Fee(INR)
                                <span className="astrick">*</span>
                              </label>
                              <input
                                type="text"
                                name="avg_anual_fee"
                                value={this.state.avg_anual_fee}
                                onChange={this.handleChange}
                                className="form-control"
                                placeholder="Enter in K's"
                              />
                              {this.validator.message('Indicative Annual Fee', this.state.avg_anual_fee, 'required', { className: 'text-danger' })}
                            </div>
                            <div className="form-group col-md-4">
                              <label
                                className={edited && (edited_data.other_fee !== this.state.other_fee) && 'edited-field'}>
                                Other Fees <span className="astrick">*</span>
                              </label>
                              <input
                                type="text"
                                name="other_fee"
                                value={this.state.other_fee}
                                onChange={this.handleChange}
                                className="form-control"
                              />
                              {this.validator.message('Other Fees', this.state.other_fee, 'required', { className: 'text-danger' })}
                            </div>
                            <div className="form-group col-md-4">
                              <label
                                className={edited && (edited_data.admit_fee !== this.state.addmission_fee) && 'edited-field'}>
                                Admission Fees <span className="astrick">*</span>
                              </label>
                              <input
                                type="text"
                                name="addmission_fee"
                                value={this.state.addmission_fee}
                                onChange={this.handleChange}
                                className="form-control"
                              />
                              {this.validator.message('Admission Fees', this.state.addmission_fee, 'required', { className: 'text-danger' })}
                            </div>
                            <div className="form-group col-md-4">
                              <label
                                className={edited && (edited_data.is_refund !== this.state.isrefund) && 'edited-field'}>
                                Is Refundable (Admission Fees)
                                <span className="astrick">*</span>
                              </label>
                              <br />
                              <input
                                type="radio"
                                value="1"
                                name="isrefund"
                                onClick={this.handleChange}
                                checked={this.state.isrefund === 1}
                              />
                              Yes&nbsp;&nbsp;
                              <input
                                type="radio"
                                name="isrefund"
                                value="0"
                                checked={this.state.isrefund === 0}
                                onClick={this.handleChange}
                              />
                              No
                              {this.validator.message('Is Refundable', this.state.isrefund, 'required', { className: 'text-danger' })}
                            </div>
                            <div className="form-group col-md-4">
                              <label
                                className={edited && (edited_data.process_fee !== this.state.processing_fee) && 'edited-field'}>
                                Application Fees <span className="astrick">*</span>
                              </label>
                              <input
                                type="text"
                                name="processing_fee"
                                value={this.state.processing_fee}
                                onChange={this.handleChange}
                                className="form-control"
                              />
                              {this.validator.message('Application Fees', this.state.processing_fee, 'required', { className: 'text-danger' })}
                            </div>

                            <div className="form-group col-md-4">
                              <label>                     
                                Current Vacancies for admissions
                              </label>
                              <div className="custom-select-drop dropdown">
                                <select
                                  name="current_vacancies"
                                  id="current_vacancies"
                                  className="form-control"
                                  // data-live-search="true"
                                  value={this.state.current_vacancies}
                                  onChange={this.handleSelect}
                                  title='Select'
                                > 
                                  <option value="">Select</option>
                                  <option value="available">Available</option>
                                  <option value="closed">Closed</option> 
                                  <option value="infonotavailable">Info not available</option>  
                                </select>
                                
                              </div>
                            </div>
                              
                            {this.state.current_vacancies==='available' &&
                            <div className="form-group col-md-4">
                              <label>                     
                                Seats available in grades
                              </label>
                              <div className="custom-select-drop dropdown">
                                <select
                                  multiple
                                  name="seats_in"
                                  id="seats_in"
                                  className="form-control"
                                  // data-live-search="true"
                                  value={this.state.seats_in}
                                  onChange={this.handleSelect}
                                  title='Select'
                                >
                                  <option value="KG">KG</option>
                                  <option value="1st">1st</option> 
                                  <option value="2nd">2nd</option> 
                                  <option value="3rd">3rd</option> 
                                  <option value="4th">4th</option> 
                                  <option value="5th">5th</option> 
                                  <option value="6th">6th</option> 
                                  <option value="7th">7th</option> 
                                  <option value="8th">8th</option> 
                                  <option value="9th">9th</option> 
                                  <option value="10th">10th</option> 
                                  <option value="11th">11th</option> 
                                  <option value="12th">12th</option>  
                                </select>
                                
                              </div>
                            </div>  
                            }
                            
                            <div className="form-group col-md-4">
                              <label
                                className={edited && (edited_data.documents !== this.state.required_document) && 'edited-field'}>Required Documents
                              </label>
                              <div className="custom-select-drop dropdown">
                                <select
                                  multiple
                                  name="required_document"
                                  id="required_document"
                                  className="form-control selectpicker"
                                  // data-live-search="true"
                                  value={this.state.required_document}
                                  onChange={this.handleSelect}
                                  title='Select'
                                >
                                  {this.state.documentList.length > 0 &&
                                    this.state.documentList.map((item, i) => {
                                      return (
                                        <option value={item.id} >
                                          {item.document_name}
                                        </option>
                                      )
                                    })}
                                </select>
                                {this.validator.message('Documents', this.state.required_document, 'required', { className: 'text-danger' })}
                              </div>
                            </div>
                            <div className="form-group col-md-4">
                              <label
                                className={edited && (edited_data.admit_process !== this.state.admission_process) && 'edited-field'}>Admission Process
                              </label>
                              <textarea
                                name="admission_process"
                                value={this.state.admission_process}
                                onChange={this.handleChange}
                                className="form-control"
                              ></textarea>
                              {this.validator.message('Admission Process', this.state.admission_process, 'required', { className: 'text-danger' })}
                            </div>


                            



                            <div className="form-group col-md-4">
                              <label
                                className={edited && (edited_data.keywords !== this.state.keywords) && 'edited-field'}>Keywords
                                {edited && (edited_data.keywords !== this.state.keywords) && <span className="astrick edited">*</span>}
                              </label>
                              <Multiselect
                                isObject={false}
                                options={this.state.keywordsArr} // Options to display in the dropdown
                                selectedValues={this.state.keywords} // Preselected value to persist in dropdown
                                onSelect={this.onSelect} // Function will trigger on select event
                                onRemove={this.onRemove} // Function will trigger on remove event
                              />
                              {/* <textarea
                                name="keywords"
                                value={this.state.keywords}
                                onChange={this.handleChange}
                                className="form-control"
                                placeholder="ex: school,category names,location name,etc"
                              ></textarea> */}
                              {/* {this.validator.message('Website Search Keywords', this.state.keywords, 'required', { className: 'text-danger' })} */}
                            </div>
                          </div>
                        </div>
                        <div className="box-shadow-custom">
                          <div className="row">
                            <div className="col-md-12 col-xs-12">
                              <span className="form-legend">Images</span>
                            </div>
                            <div className="form-group col-md-4">
                              <label className={edited && (edited_data.images !== this.state.images) && 'edited-field'}>
                                Banner Images <span className="astrick">*</span>
                              </label>
                              <input
                                type="file"
                                name="images"
                                onChange={this.handleFile}
                                className="form-control"
                              />
                              {this.validator.message('Banner Image', this.state.images, '', { className: 'text-danger error-msg' })}
                              {/* {this.validator.message('Banner Image', this.state.images, 'checkExist', { className: 'text-danger error-msg' })} */}
                            </div>
                            {(this.state.edit_image !== '' || this.state.tempBanner !== '') &&
                              (
                                <div class="col-md-2 col-sm-12 mar-btm" id="edit_image">

                                  <img src={this.state.tempBanner ? this.state.tempBanner : this.state.edit_image} alt="Banner" class="img-thumbnail" />

                                </div>
                              )
                            }

                            <div class="col-md-12 float-left mt-4 p-0">
                              <label
                                className={edited && (edited_data.photos !== this.state.photos) && 'edited-field'}>
                                Gallery Images <span className="astrick">*</span>
                              </label>
                            </div>

                            <div class="col-md-12 float-left mt-4 p-0">

                              <div class="col-md-12 margin-bottom-mobile-account float-left image-upload">
                                <div className='upload-wizard'>
                                  <div className='upload-thumb'>
                                    <ul className='list-inline'>
                                      {this.state.attachment_file.map((file_data, index) => {

                                        var file_url;
                                        if (file_data.name) {
                                          let url = file_data.image_thumb ? file_data.image_thumb : '';
                                          if (url !== '') {
                                            file_url = file_data.image_thumb;
                                          } else {
                                            file_url = URL.createObjectURL(file_data);
                                          }
                                          if (file_data.type === 'application/pdf') {
                                            console.log('blob_url', file_url.names)
                                            return (
                                              <li className='previewImg'>
                                                <div className='thumb-img'>
                                                  <img
                                                    src={file_url}
                                                    alt='preview'
                                                    title={file_data.name}
                                                  />
                                                </div>

                                                <a href='javascript:;' className='del-btn' onClick={() => {
                                                  this.removeImage(file_data.name)
                                                }}>
                                                  <img
                                                    src={'../../../assets/images/close-icon-white.svg'}
                                                    alt='delete'
                                                  />
                                                </a>
                                              </li>
                                            )
                                          } else {
                                            return (
                                              <li className='previewImg'>
                                                <div className='thumb-img'>
                                                  <img
                                                    src={file_url}
                                                    alt='preview'
                                                    title={file_data.name}
                                                  />
                                                </div>
                                                {/* <span className='file-name'>{file_data.name}</span> */}
                                                <a
                                                  href='javascript:;'
                                                  className='del-btn'
                                                  onClick={() => {
                                                    this.removeImage(file_data.name)
                                                  }}
                                                >
                                                  <img
                                                    src={'../../../assets/images/close-icon-white.svg'}
                                                    alt='delete'
                                                  />
                                                </a>
                                              </li>
                                            )
                                          }
                                        } else {
                                          return undefined
                                        }
                                      })}
                                      <li className='addMore'>
                                        <input
                                          type='file'
                                          name='imgInp[]'
                                          id='imgInp2'
                                          className='add_img'
                                          multiple
                                          onChange={this.loadFile.bind(this)}
                                          accept="image/x-png,image/gif,image/jpeg"
                                        />
                                        <a href='javascript:;' className='add-more'>
                                          <div>
                                            <img src={'../../../assets/images/upload-icon.svg'} alt='icon' />
                                            Add more
                                          </div>
                                        </a>
                                      </li>
                                    </ul>
                                  </div>

                                </div>

                              </div>

                              {this.validator.message('gallery images', this.state.attachment_file, '', { className: 'text-danger error-msg' })}
                              {/* {this.validator.message('gallery images', this.state.attachment_file, 'required', { className: 'text-danger error-msg' })} */}

                            </div>
                          </div>
                        </div>
                        <div className="col-md-12 col-xs-12 btn-bdr">
                          <button id="btnSubmit" className="btn btn-primary btn-sm">Preview</button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>


              </div>

                    </div>
                  

              
                </div>
              </div>
            </div>
            
             {this.preview()}
                </AdminLayout>
            </React.Fragment>
    );
  }
  preview = () => {
    let boe = this.state.categorySubTypeList.map((item) =>
      this.state.sub_types.includes(item.id.toString()) ? item.name : ''
    );
    boe = boe.filter(n => n).toString();
    let grade_from = this.state.gradeList.map((item) => {
      if (item.id === this.state.grade) return item.name
    })
    grade_from = grade_from.filter(n => n).toString();
    let grade_to = this.state.gradeList.map((item) => {
      if (item.id === this.state.grade_to) return item.name
    })
    grade_to = grade_to.filter(n => n).toString();
    let from_time = this.state.timingList.map((item) => {
      if (item.id === this.state.from_time) return item.timing
    })
    from_time = from_time.filter(n => n).toString();
    let to_time = this.state.timingList.map((item) => {
      if (item.id === this.state.to_time) return item.timing
    })
    to_time = to_time.filter(n => n).toString();
    return (
      <Modal isOpen={this.state.preview} size='lg' className='preview-pop'>
        <ModalBody className=''>
          <Row>
            <Col md='12'>
              <img src='/assets/images/user-header.png' className='preview-header' alt="header" />
            </Col>
          </Row>
          <Row className='pv-banner'>
            <Col className='pv-banner-bg' md='12'>
              <div className='title-section'>
                <p className="banner-title">{this.state.schoolName}</p>
                <p className="banner-address">{this.state.address}</p>
              </div>
            </Col>
          </Row>
          <Row className='pv-section'>
            <Col className='' md='12'>
              <div className='title-section'>
                <h4>About the School</h4>
                <p className="">{this.state.about_school}</p>
              </div>
            </Col>
          </Row>
          <Row className='pv-section'>
            <Col className='' md='12'>
              <div className='title-section'>
                <h4>Key Information</h4>
                <div className='row'>
                  <div className='col-md-4'>
                    <div className='type-n7ngd'><b>School Type</b></div>
                    <div className='key-po'>
                      
                      {this.state.boeList.map((item) => {
                        if (item.category_id === this.state.board_of_education) {
                          return (
                            item.category_name
                          )
                        }
                      })}
                    </div>
                  </div>
                  <div className='col-md-4'>
                    <div className='type-n7ngd'><b>Board Of Education</b></div>
                    <div className='key-po'>
                      <p>{boe}</p>
                    </div>
                  </div>
                  <div className='col-md-4'>
                    <div className='type-n7ngd'><b>Grades</b></div>
                    <div className='key-po'>
                      <p>
                        {grade_from === 'NA' || grade_to === 'NA' ? 'NA' : `${grade_from} - ${grade_to}`}
                      </p>
                    </div>
                  </div>
                  <div className='col-md-4'>
                    <div className='type-n7ngd'><b>Min Age of Admission</b></div>
                    <div className='key-po'>
                      <p>{this.state.min_age}</p>
                    </div>
                  </div>
                  <div className='col-md-4'>
                    <div className='type-n7ngd'><b>Establishment Year</b></div>
                    <div className='key-po'>
                      <p>{this.state.establishment_Year}</p>
                    </div>
                  </div>
                  <div className='col-md-4'>
                    <div className='type-n7ngd'><b>Landline Number</b></div>
                    <div className='key-po'>
                      <p>{this.state.landline_number}</p>
                    </div>
                  </div>
                  
                  <div className='col-md-4'>
                    <div className='type-n7ngd'><b>School Timing</b></div>
                    <div className='key-po'>
                      <p>
                        {from_time === 'NA' || to_time === 'NA' ? 'NA' :
                          `${from_time} ${this.state.from_time_cate} - ${to_time} ${this.state.to_time_cate}`}
                      </p>
                    </div>
                  </div>
                  <div className='col-md-4'>
                    <div className='type-n7ngd'><b>Location</b></div>
                    <div className='key-po'>
                      <p>
                        {this.state.location}
                      </p>
                    </div>
                  </div>
                  <div className='col-md-4'>
                    <div className='type-n7ngd'><b>Teacher:Student Ratio</b></div>
                    <div className='key-po'>
                      <p>
                        {this.state.stdRatio}
                      </p>
                    </div>
                  </div>
                  <div className='col-md-4'>
                    <div className='type-n7ngd'><b>Is Refundable (Admission Fees)</b></div>
                    <div className='key-po'>
                      <p>
                        {this.state.isrefund === 1 ? 'Yes' : 'No'}
                      </p>
                    </div>
                  </div>
                  <div className='col-md-4'>
                    <div className='type-n7ngd'><b>Scholarship Facility</b></div>
                    <div className='key-po'>
                      <p>
                        {this.state.has_scholarship === 0 ? 'NA' :
                          (this.state.has_scholarship === 1 ? 'Yes, ' : 'No')}
                        &nbsp;{this.state.has_scholarship === 1 && (this.state.scholarship_desc)}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
          <Row className='pv-section'>
            <Col className='' md='12'>
              <div className='title-section'>
                <h4>Amenities</h4>
                <div className='row'>
                  {this.state.facilities.map((item) => {
                    let fac_data = this.state.facilitiesList.filter((data) => data.id === item);
                    if (fac_data.length > 0) {
                      return (
                        <div className='col-md-4'>
                          <div className=''>
                            {fac_data[0].facility}
                          </div>
                        </div>
                      )
                    }
                  })}

                </div>
              </div>
            </Col>
          </Row>
          <Row className='pv-section'>
            <Col className='' md='12'>
              <div className='title-section'>
                <h4>Gallery</h4>
                <div className='row'>
                  {this.state.attachment_file.map((item) => {
                    console.log('********', item);
                    if (item.image_thumb) {
                      return (
                        <div className='col-md-4'>
                          <img src={item.image_thumb} className='preview-image' alt="preview"/>
                        </div>
                      )
                    } else if (item.name) {
                      let file_url = URL.createObjectURL(item);
                      return (
                        <div className='col-md-4'>
                          <img src={file_url} className='preview-image' alt="preview" />
                        </div>
                      )
                    }
                  })}
                  {this.state.attachment_file.length === 0 && (
                    <div className='col-md-4'>No Gallery Images Found</div>
                  )}
                </div>
              </div>
            </Col>
          </Row>
          <Row className='pv-section'>
            <Col className='' md='12'>
              <div className='title-section'>
                <h4>Fees Structure</h4>
                <div className='row'>
                  <div className='col-md-4'>
                    Indicative Annual Fee : {this.state.avg_anual_fee > 0 ? this.state.avg_anual_fee : 'NA'}
                  </div>
                  <div className='col-md-4'>
                    Recurring Fees : {this.state.addmission_fee > 0 ? this.state.addmission_fee : 'NA'}
                  </div>
                  <div className='col-md-4'>
                    Other Fees : {this.state.other_fee > 0 ? this.state.other_fee : 'NA'}
                  </div>
                </div>
              </div>
            </Col>
          </Row>
          <Row className='pv-section'>
            <Col className='' md='12'>
              <div className='title-section'>
                <h4>Admission Details</h4>
                <div className='row'>
                  <div className='col-md-6'>
                    Admission Link : {this.state.admission_link ?
                      (<a href={this.state.admission_link}>Link</a>) : 'NA'}
                  </div>
                  <div className='col-md-6'>
                    Admission Process : {this.state.admission_process}
                  </div>
                </div>
              </div>
            </Col>
          </Row>
          <Row className='pv-section'>
            <Col className='' md='12'>
              <div className='title-section'>
                <h4>Required Documents</h4>
                <div className='row'>
                  {this.state.required_document.map((item) => {
                    let redoc_data = this.state.documentList.filter((data) => data.id === item);
                    if (redoc_data.length > 0) {
                      return (
                        <div className='col-md-4'>
                          <div className=''>
                            {redoc_data[0].document_name}
                          </div>
                        </div>
                      )
                    }
                  })}

                </div>
              </div>
            </Col>
          </Row>
          <Row className='pv-section'>
            <Col className='' md='12'>
              <div className='title-section'>
                <h4>Contact Information</h4>
                <div className='row'>
                  <div className='col-md-4'>
                    Email Id : {this.state.email_id}
                  </div>
                  <div className='col-md-4'>
                    Contact : {this.state.phone_number}
                  </div>
                  <div className='col-md-4'>
                    Website : {this.state.website}
                  </div>
                </div>
              </div>
            </Col>
          </Row>
          <Row className='pv-section'>
            <Col className='' md='12'>
              <button className='btn btn-sm btn-primary custome-submit' onClick={this.handleSubmit}>
                {this.state.edited && this.state.role === 1 ? 'Approve' : 'Submit'}
              </button>
              {this.state.edited && this.state.role === 1 && (
                <button className='btn btn-sm btn-danger custome-submit' style={{ marginLeft: '10px' }}
                  onClick={this.handleReject}>
                  Reject
                </button>
              )}
              <button className='btn btn-sm btn-defult custome-submit' style={{ marginLeft: '10px' }}
                onClick={() => { this.setState({ preview: false }) }}>Close</button>
            </Col>
          </Row>
        </ModalBody>
      </Modal >
    )
  }
  handleSubmit = (e) => {
    e.preventDefault();
    if (this.validator.allValid()) {
      let ins = {
        id: this.id ? this.id : '',
        about: this.state.about_school,
        admit_fee: this.state.addmission_fee,
        address: this.state.address,
        admit_link: this.state.admission_link,
        admit_process: this.state.admission_process,
        avg_fee: this.state.avg_anual_fee,
        sub_categories: this.state.board_of_education,
        sub_types: this.state.sub_types,
        sub_type: this.state.sub_type,
        bof: this.state.board_of_education,
        classification: this.state.classification,
        country: this.state.country,
        email_id: this.state.email_id,
        est_year: this.state.establishment_Year,
        facilites: this.state.facilities,
        fax_number: this.state.fax_number,
        google_location: this.state.google_location,
        grade: this.state.grade,
        grade_to: this.state.grade_to,
        images: this.state.images,
        inst_lang: this.state.instruction_lang,
        is_refund: this.state.isrefund,
        landline_no: this.state.landline_number,
        location: this.state.location,
        min_age: this.state.min_age,
        teacher_student_ratio: this.state.stdRatio,
        // mop: this.state.mode_of_payment,
        other_fee: this.state.other_fee,
        owner_name: this.state.ownerName,
        phone_number: this.state.phone_number,
        photos: this.state.attachment_file ? this.state.attachment_file : '',
        pincode: this.state.pincode,
        process_fee: this.state.processing_fee,
        registration_no: this.state.registration_no,
        documents: this.state.required_document,
        organisation_name: this.state.schoolName,
        school_type: this.state.schoolType,
        timing: this.state.school_timimg,
        state: this.state.state,
        website: this.state.website,
        latitude: this.state.latitude,
        longitude: this.state.longitude,
        other_rating: this.state.other_rating,
        from_time: this.state.from_time,
        to_time: this.state.to_time,
        from_time_cate: this.state.from_time_cate,
        to_time_cate: this.state.to_time_cate,
        keywords: this.state.keywords ? this.state.keywords.join(';') : '',
        delete_array: this.state.delete_array,
        has_scholarship: this.state.has_scholarship,
        scholarship_desc: this.state.scholarship_desc,
        login_id: this.state.login_id,
        prescl_link: this.state.prescl_link,
        role: this.state.role,
        admission_open : this.state.admission_open,
        admission_closed : this.state.admission_closed,
        seats_in : this.state.seats_in,
        current_vacancies : this.state.current_vacancies
      }

      createSchool(ins).then((res) => {
        if (res.status === 1) {
          alert("Saved successfully");
          window.location.href = document.referrer;
        } else {
          jQuery("#btnSubmit").attr('disabled', false);
          alert("Error in saving");
        }
      });
    }
    else {
      this.validator.showMessages();
      this.forceUpdate();
    }
  };
  handleReject = (e) => {
    e.preventDefault();
    let req = JSON.stringify({
      id: this.state.pageid
    })
    let toastr = '';
    sclReject(req).then((res => {
      if (res.status === 1) {
        toastr = window.toastr.success;
        toastr('success', {
          positionClass: "toast-bottom-right",
          containerId: "toast-bottom-right"
        });
        window.location.href = document.referrer;
      }
    }))
  }
}

export default verticalSchool;


// WEBPACK FOOTER //
// ./src/components/bewise/verticalSchoolEdit.jsx